var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"admin-preview-banner"},[_c('span',{staticClass:"banner-icon"},[_vm._v("⚠")]),_c('span',{staticClass:"banner-text"},[_vm._v("管理员预览模式 — 当前显示包含未发布的草稿数据，普通用户看不到此内容")]),_c('button',{staticClass:"banner-close",attrs:{"title":"关闭提示"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("×")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }